import Img1 from "../../assets/img/giftcard/1.jpeg";
import { useTranslation } from "react-i18next";

const Giftcard = () => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 text-center mb-3">
          <img src={Img1} alt="img" className="img-fluid rounded" width="1748" height="1240" />
        </div>
      </div>
      <div>
        <br />
        <h2>{t('giftcard.heading')}</h2>
        <br />
        <p>{t('giftcard.intro')}</p>
        <ul>
          {t('giftcard.items', { returnObjects: true }).map((item, i) => (
            <li key={i}>- {item}</li>
          ))}
        </ul>
        <br />
        <h3>{t('giftcard.whyTitle')}</h3>
        <ul>
          {t('giftcard.whyItems', { returnObjects: true }).map((item, i) => (
            <li key={i}>- {item}</li>
          ))}
        </ul>
        <br />
        <h3 id="kako-kupiti">{t('giftcard.howTitle')}</h3>
        <p>{t('giftcard.howText')}</p>
      </div>
    </div>
  );
};

export default Giftcard;
